export const GET_ALL_PROMOTIONS = "GET_ALL_PROMOTIONS"
export const GET_ALL_PROMOTIONS_RESPONSE_SUCCESS =
  "GET_ALL_PROMOTIONS_RESPONSE_SUCCESS"
export const CREATE_PROMOTION = "CREATE_PROMOTION"
export const UPDATE_PROMOTION = "UPDATE_PROMOTION"
export const DELETE_PROMOTION = "DELETE_PROMOTION"
